import React, { useState } from 'react';
import { APIProvider, Map, InfoWindow } from '@vis.gl/react-google-maps';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { useAtom } from 'jotai';
import { carLocationsAtom } from '../atoms/carLocationsAtom';
import { mapCenterAtom, mapZoomAtom } from '../atoms/carLocationsAtom';
import  { Chip } from "@mui/material";     
import { allCarsAtom } from '../atoms/allCarsAtom';
import { CarLocate } from '../atoms/carLocationsAtom';
import { statusColors } from '../atoms/allCarsAtom';

// const polygons = [
//   // Auto Cross area
//   [
//     { lng: -71.4600557, lat: 43.358903 },
//     { lng: -71.4599859, lat: 43.3570504 },
//     { lng: -71.4575398, lat: 43.3570582 },
//     { lng: -71.4575666, lat: 43.3589537 },
//     { lng: -71.4600557, lat: 43.358903 },
//   ],
//   // Brake Test area
//   [
//     { lng: -71.4601947, lat: 43.3651116 },
//     { lng: -71.4604307, lat: 43.3645714 },
//     { lng: -71.4589636, lat: 43.364199 },
//     { lng: -71.4587516, lat: 43.3647508 },
//     { lng: -71.4601947, lat: 43.3651116 },
//   ],
//   // Acceleration Test area
//   [
//     { lng: -71.461201, lat: 43.3647126 },
//     { lng: -71.4627996, lat: 43.3612338 },
//     { lng: -71.4624026, lat: 43.3611246 },
//     { lng: -71.4607933, lat: 43.3646112 },
//     { lng: -71.461201, lat: 43.3647126 },
//   ],
//   // Garage
//   [
//     { lng: -71.4598178, lat: 43.3643469 },
//     { lng: -71.4599224, lat: 43.3641373 },
//     { lng: -71.4593546, lat: 43.3639943 },
//     { lng: -71.4592473, lat: 43.3642058 },
//     { lng: -71.4598178, lat: 43.3643469 },
//     { lng: -71.4598178, lat: 43.3643469 },
//   ],
//   // Tech Test area
//   [
//     { lng: -71.4592473, lat: 43.3642058 },
//     { lng: -71.4593546, lat: 43.3639943 },
//     { lng: -71.4592976, lat: 43.3639802 },
//     { lng: -71.4591896, lat: 43.3639524 },
//     { lng: -71.4590891, lat: 43.3641668 },
//     { lng: -71.4591917, lat: 43.3641927 },
//     { lng: -71.4592473, lat: 43.3642058 }
//   ],
//   // Endurance
//   [
//     { lng: -71.4591712, lat: 43.3662222 },
//     { lng: - 71.4594931, lat: 43.3653487 },
//     { lng: -71.4583988, lat: 43.3649119 },
//     { lng: -71.4602656, lat: 43.3602474 },
//     { lng: -71.4598579, lat: 43.3592022 },
//     { lng: -71.4578623, lat: 43.3592334 },
//     { lng: -71.4566607, lat: 43.3657387 },
//     { lng: -71.4591712, lat: 43.3662222 }
//   ]
// ];


const getMarkerStyle = (status: string) => {
  const color = statusColors[status as keyof typeof statusColors] || 'grey';
  return {
    background: color,
    borderColor: color,
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
  };
};

const EventMap = () => {
  const [carLocations] = useAtom(carLocationsAtom);
  const [allCarState] = useAtom(allCarsAtom);
  const [mapCenter] = useAtom(mapCenterAtom);
  const [zoomState] = useAtom(mapZoomAtom);
  const [selectedCar, setSelectedCar] = useState<CarLocate | null>(null);

  const handleMarkerClick = (carLocation: CarLocate) => {
     setSelectedCar(selectedCar === carLocation ? null : carLocation);
  };

  return (
    <APIProvider apiKey="AIzaSyDYZA7VHWtg3w6W0W1QDwkHAoo_MuQV_IU">
      <Map
        key={JSON.stringify(mapCenter)}
        style={{ width: '100%', height: '100%' }}
        defaultCenter={mapCenter}
        defaultZoom={zoomState.zoom}
        mapId='56128e7cf3900e81'
        mapTypeId = 'satellite'
      >
        {/* {polygons.map((path, index) => (
          <Polygon
            key={index}
            paths={path}
            strokeColor={colors[index]} 
            fillColor={colors[index]} 
            strokeOpacity={1}
            strokeWeight={2}
            fillOpacity={0.35}
          />
        ))} */}
        {carLocations?.map((carLocation, index) => {
          const car = allCarState?.find(car => car.CarNumber === carLocation.CarNumber);
          const markerStyle = getMarkerStyle(carLocation.Status || 'Queued');

          return (
            <React.Fragment key={index}>
              <AdvancedMarker
                position={{ lat: carLocation.Lat, lng: carLocation.Long }}
                onClick={() => handleMarkerClick(carLocation)}
              >
                <div style={markerStyle}>
                  {carLocation.CarNumber}
                </div>
              </AdvancedMarker>
              {selectedCar === carLocation && car && (
                <InfoWindow
                  position={{ lat: carLocation.Lat, lng: carLocation.Long }}
                  onCloseClick={() => setSelectedCar(null)}
                >
                  <div>
                    <h2>{car.CarNumber}</h2>
                    <p>{car.Institution}</p>
                    <Chip
                      label={carLocation.Status || " "}
                      sx={{
                        bgcolor: carLocation.Status ? statusColors[carLocation.Status as keyof typeof statusColors] || 'grey' : 'grey',
                        color: 'white'
                      }}
                    />
                  </div>
                </InfoWindow>
              )}
            </React.Fragment>
          );
        })}
      </Map>
    </APIProvider>
  );
};

export default EventMap;